/**
 * Phone message status based on send result
 */
export enum MessageStatusEnum {
  /**
   * Message exists but is not yet dispatched (outbound only)
   */
  DRAFT = "draft",

  /**
   * Message is queued for sending (outbound only)
   */
  QUEUED = "queued",

  /**
   * Message has left the system (outbound) OR
   * message has entered the system (inbound)
   */
  PROCESSED = "processed",

  /**
   * Message processing failed
   */
  ERROR = "error"
}
